import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Form,
  Button,
} from "react-bootstrap";
import { FaLock } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APIServicenew from "../utils/APIGeneralService";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  // ✅ Get token from query string
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const resetToken = queryParams.get("token");
    if (!resetToken) {
      toast.error("Invalid or missing token.");
      navigate("/"); // redirect to home or login
    }
    setToken(resetToken);
  }, [location, navigate]);

  const validate = () => {
    const errs = {};
    if (!newPassword) {
      errs.newPassword = "New password is required.";
    } else if (newPassword.length < 6) {
      errs.newPassword = "Password must be at least 6 characters.";
    }

    if (newPassword !== confirmPassword) {
      errs.confirmPassword = "Passwords do not match.";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validate()) {
      setLoading(false);
      return;
    }

    try {
      const res = await APIServices.post("admin/reset_password", {
        token,
        password: newPassword,
      });

      if (res?.data?.status === true) {
        toast.success(res?.data?.message || "Password reset successful!");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } catch (err) {
      toast.error("Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="login_sec reset_password_sec">
        <Container fluid className="p-0">
          <Row className="gx-0 align-items-center">
            <Col md={6} lg={6}>
              <div className="login_graph p-4">
                <img
                  src="/images/vector.svg"
                  className="img-fluid"
                  alt="login"
                />
              </div>
            </Col>
            <Col md={6} lg={6}>
              <div className="login_form p-4">
                <div className="text-center mb-4">
                  <img
                    src="/images/msl_logo.png"
                    alt="Logo"
                    className="img-fluid"
                    style={{ width: "200px" }}
                  />
                </div>
                <h2 className="font_blue_20 font-600 mb-4 text-center">
                  Reset Password
                </h2>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>New Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="password"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => {
                          setNewPassword(e.target.value);
                          setErrors((prev) => ({ ...prev, newPassword: "" }));
                        }}
                        maxLength={20}
                      />
                      <InputGroup.Text>
                        <FaLock />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.newPassword && (
                      <div className="text-danger mt-2">
                        {errors.newPassword}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Confirm Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="password"
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setErrors((prev) => ({
                            ...prev,
                            confirmPassword: "",
                          }));
                        }}
                        maxLength={20}
                      />
                      <InputGroup.Text>
                        <FaLock />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.confirmPassword && (
                      <div className="text-danger mt-2">
                        {errors.confirmPassword}
                      </div>
                    )}
                  </Form.Group>

                  <Button
                    className="btn red_button w-100"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Resetting..." : "Reset Password"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </>
  );
};

export default ResetPassword;
